<template>
  <el-breadcrumb separator-icon="el-icon-arrow-right" class="breadcrumb">
    <el-breadcrumb-item v-for="(item, key) in breadList" :key="key" :to="item.path">{{ item.meta && item.meta.title }}</el-breadcrumb-item>
    <slot></slot>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    removeHeader: Boolean, // 是否去头
    removeLast: Boolean // 是否去尾
  },
  data () {
    return {
      breadList: []
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      this.breadList = [] // 初始化清空
      this.$route.matched.forEach(item => {
        if (item.name === 'layout') return // 公用模块
        this.breadList.push(item)
        this.removeHeader && this.breadList.shift()
        this.removeLast && this.breadList.pop()
      })
    }
  }
}
</script>